import { render, staticRenderFns } from "./LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado.vue?vue&type=template&id=15bc9889&scoped=true"
import script from "./LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorEsclarecimentoImpugnacaoNaoHabilitado.vue?vue&type=style&index=0&id=15bc9889&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc9889",
  null
  
)

export default component.exports